import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/order_snapshot_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  order_id_eq: {
    column_type: 'belongs_to',
    label_key_path: 'orderSnapshot.order',
    extra: {
      model_name: 'Order',
      display_column: 'id',
    },
    model_name: 'OrderSnapshot',
  },
  order: {
    column_type: 'belongs_to',
    label_key_path: 'orderSnapshot.order',
    extra: {
      model_name: 'Order',
      display_column: 'id',
    },
    model_name: 'OrderSnapshot',
  },
  readed_eq: {
    column_type: 'boolean',
    model_name: 'OrderSnapshot',
    label_key_path: 'orderSnapshot.readed',
  },
}
export const formColumnsConfig = {
 'self': {}
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('OrderSnapshot', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('OrderSnapshot', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
